import React, { ReactElement } from 'react';
import { ResourceState } from 'ia-react-core/~/interfaces/ResourceState';

import { StringKeyOf } from 'ia-react-core/~/interfaces/StringKeyOf';
import ResourceResolver, { ResourceResolverProps } from '../#ResourceResolver';
import Mapper from '../../redux/Mapper';
import Resource from '../Resource';

export interface ResourceMapperProps<Data, Error = {}> extends Omit<ResourceResolverProps<Data, Error>, 'children'> {
  /** A function getting the mapped values */
  children: (renderProps: ResourceState) => ReactElement;
  /** Keys from the Resource scope to map. By default will map every value from the resource. */
  keys?: string[];
}

const ResourceMapperDefaultsProps = {
  keys: Resource.scopeProps,
};

/**
 * @since 0.21.0
 */
const ResourceMapper = Object.assign(
  <Data, Error = {}>({
    children, keys, ...props
  }: ResourceMapperProps<Data, Error>) => (
    <ResourceResolver {...props}>
      {({ resourceSrc }) => (
        <Mapper<ResourceState>
          src={keys.reduce((result, key) => {
            result[key] = `${resourceSrc}.${key}`;
            return result;
          }, {} as Record<string, string>)}
        >
          {(values) => children(values)}
        </Mapper>
      )}
    </ResourceResolver>
  ),
  {
    defaultProps: ResourceMapperDefaultsProps,
    publicProps: ['keys', ...ResourceResolver.publicProps] as StringKeyOf<ResourceMapperProps<
    any>>[],
  },
);

export default ResourceMapper;
